/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var EyeOpenIcon20Solid = forwardRef('EyeOpenIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.498 10a2.502 2.502 0 1 1 5.004 0 2.502 2.502 0 0 1-5.004 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2.905c-4.528 0-8.403 2.796-9.935 6.745a.967.967 0 0 0 0 .7c1.532 3.949 5.407 6.745 9.935 6.745 4.528 0 8.403-2.796 9.934-6.745a.968.968 0 0 0 0-.7C18.404 5.701 14.529 2.905 10 2.905Zm0 2.593a4.502 4.502 0 1 0 0 9.004 4.502 4.502 0 0 0 0-9.004Z" })));
});
